import { Button } from "@/components/ui/button";
import type { WhoDrugRecodeBinding } from "../hooks/useWhoDrugRecode";

export function WhoDrugRecommendations({ coding: c }: { coding: WhoDrugRecodeBinding }) {
  if (!c.recommendations.length) return null;
  return <div className="cr-whodrug-recommendations" aria-live="polite">
    {c.recommendations.map(entry => <article key={entry.rid} className="cr-whodrug-recommendation">
      <p className="text-xs text-muted-foreground">TheraGenie found another entry. Your selection is unchanged.</p>
      <h3 className="font-medium">{entry.name}</h3>
      <p className="text-xs text-muted-foreground">RID {entry.rid} · {entry.code} · {entry.version}</p>
      <p className="text-sm">{entry.rationale}</p>
      <Button variant="outline" disabled={c.applying || c.disabled} onClick={() => c.reviewRecommendation(entry.rid)}>
        View suggestion<span className="sr-only">: {entry.name}, RID {entry.rid}</span>
      </Button>
    </article>)}
  </div>;
}
